import { render, staticRenderFns } from "./SideMenuStudyEditor.vue?vue&type=template&id=08e88544&"
import script from "./SideMenuStudyEditor.vue?vue&type=script&lang=js&"
export * from "./SideMenuStudyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e88544')) {
      api.createRecord('08e88544', component.options)
    } else {
      api.reload('08e88544', component.options)
    }
    module.hot.accept("./SideMenuStudyEditor.vue?vue&type=template&id=08e88544&", function () {
      api.rerender('08e88544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuStudyEditor.vue"
export default component.exports